<modal (close)="closeModal()" class="checkin-modal" title="Check-In" data-testid="checkin-legal-modal">
  <p><b>Para poder cumplir con la normativa 933/2021 de Registro de Viajeros, es necesario que, antes de acceder al
    alojamiento, se registren todos los huéspedes</b> incluyendo los menores de edad.</p>
  <p>En el caso de los menores de edad, el registro deberá ser completado por el adulto responsable indicando su
    parentesco.</p>
  <p>No escaneamos el documento de identidad completo ni almacenamos las imágenes. Solo extraemos mediante OCR, los
    datos mínimos necesarios mediante la lectura de la banda MRZ del documento de identidad o pasaporte, para poder
    así realizar el Parte de Viajeros que ha ser comunicado, diariamente, a las Fuerzas y Cuerpos de seguridad del
    Estado.</p>
  <p>Puedes ver los datos extraídos y la Política de Privacidad del propietario del alojamiento en el proceso de
    registro y firma del parte.</p>
  <menu-buttons [topActions]="checkinActions" (actionClick)="onCheckinActionClick($event)"></menu-buttons>
</modal>
